<template>
  <div v-if="task">
    <task-body
      :task="task"
      :try-join="tryJoin"
      :try-leave="tryLeave"
      :joined="joinBtnState"
      :join-pending="joinPending"
      :global-rules="globalRules"
      :user-left="userLeft"
      :user-rejected="userRejected"
      :rejected-reason="rejectedReason"
      :participant="participant"
    />
    <box>
      <h3 class="mb-5">{{ $tc('reward', 2) }}</h3>
      <div class="mb-1">
        <masonry :cols="{ default: 3, 1200: 2, 992: 1 }" :gutter="20">
          <reward
            v-if="task.rewardTweet"
            class="mb-4"
            :title="$filters.capitalize($tc('tweets', 1))"
            :icon="getIcon(task.type, 'Tweet')"
            :metric-title="$tc('follower', 2)"
            :value="task.rewardTweet"
          >
            <div
              v-if="rewardRules.rewardTweet.length"
              class="mt-2"
              slot="bottom"
            >
              <h6 class="pb-0 col-form-label text-uppercase">
                {{ $tc('rule', 2) }}
              </h6>
              <div v-for="rule in rewardRules.rewardTweet" :key="rule.name">
                <span class="text-lighten">{{ rule.name }}:</span>
                {{ rule.value }}
              </div>
            </div>
          </reward>
          <reward
            v-if="task.rewardRetweet"
            class="mb-4"
            :title="$filters.capitalize($tc('retweet', 1))"
            :icon="getIcon(task.type, 'Retweet')"
            :metric-title="$tc('follower', 2)"
            :value="task.rewardRetweet"
          >
            <div class="mt-2" slot="bottom">
              <h6 class="pb-0 col-form-label text-uppercase">
                {{ $tc('rule', 2) }}
              </h6>
              <div>
                <span class="text-lighten">{{ $t('maxTweetAgeDays') }}</span>
                : {{ task.rewardRetweet.params.maxTweetAge }}
                {{ $tc('day', 1) }}
              </div>
            </div>
          </reward>
          <reward
            v-if="task.rewardComment"
            class="mb-4"
            :title="$filters.capitalize($tc('comment', 1))"
            :icon="getIcon(task.type, 'Comment')"
            :metric-title="$tc('follower', 2)"
            :value="task.rewardComment"
          >
            <div
              v-if="rewardRules.rewardComment.length"
              class="mt-2"
              slot="bottom"
            >
              <h6 class="pb-0 col-form-label text-uppercase">
                {{ $tc('rule', 2) }}
              </h6>
              <div v-for="rule in rewardRules.rewardComment" :key="rule.name">
                <span class="text-lighten">{{ rule.name }}:</span>
                {{ rule.value }}
              </div>
            </div>
          </reward>
          <reward
            v-if="task.rewardLike"
            class="mb-4"
            :title="$filters.capitalize($tc('like', 1))"
            :icon="getIcon(task.type, 'Like')"
            :metric-title="$tc('follower', 2)"
            :value="task.rewardLike"
          >
            <div
              v-if="rewardRules.rewardLike.length"
              class="mt-2"
              slot="bottom"
            >
              <h6 class="pb-0 col-form-label text-uppercase">
                {{ $tc('rule', 2) }}
              </h6>
              <div v-for="rule in rewardRules.rewardLike" :key="rule.name">
                <span class="text-lighten">{{ rule.name }}:</span>
                {{ rule.value }}
              </div>
            </div>
          </reward>
        </masonry>
      </div>
    </box>
  </div>
</template>

<script>
import taskMixin from './../../mixins/task.js';

export default {
  mixins: [taskMixin],

  computed: {
    rewardRules() {
      return {
        rewardTweet: [
          {
            name: this.$t('leaveMention'),
            value: `@${this.task.link}`
          },
          {
            name: this.$t('minCharWithTags'),
            value: this.task.rewardTweet
              ? this.task.rewardTweet.params.minLength
              : null
          },
          {
            name: this.$tc('hashTagsMustAdd', 2),
            value:
              this.task.rewardTweet && this.task.rewardTweet.params.hashtags
                ? ['', ...this.task.rewardTweet.params.hashtags].join(' #')
                : null
          }
        ].filter(el => el.value),
        rewardComment: [
          {
            name: this.$t('maxTweetAgeDays'),
            value:
              this.task.rewardComment &&
              this.task.rewardComment.params.maxTweetAge
                ? `${this.task.rewardComment.params.maxTweetAge} days`
                : null
          },
          {
            name: this.$t('minCharWithTags'),
            value: this.task.rewardComment
              ? this.task.rewardComment.params.minLength
              : null
          }
        ].filter(el => el.value),
        rewardLike: [
          {
            name: this.$t('maxTweetAgeDays'),
            value:
              this.task.rewardLike && this.task.rewardLike.params.maxTweetAge
                ? `${this.task.rewardLike.params.maxTweetAge} days`
                : null
          }
        ].filter(el => el.value)
      };
    },
    globalRules() {
      return [
        {
          name: this.$t('minFollowers'),
          value: this.task.minFollowers
        },
        {
          name: this.$t('minAccountAgeMonth'),
          value: this.task.minAccountAge
        }
      ];
    }
  },

  methods: {
    tryJoin() {
      const socialNetworks = this.$store.state.app.user.socialNetworks || {};

      if (!socialNetworks.twitter) {
        this.$notify('alert', {
          text: this.$t('connectNetworks.connectTwitterAtFirst'),
          variant: 'danger',
          time: 0
        });
        return;
      }
      this.join();
    }
  }
};
</script>
